import { defineMessages } from 'react-intl';

const _default_1: {
	changeAssigneeRuleName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	checkFieldValueRuleName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restrictIssueTransitionRuleName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	updateFieldRuleName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validateFieldRuleName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ruleHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	changeAssigneeRuleName: {
		id: 'jira-workflow-editor.workflow-builder.change-assignee-rule-name',
		defaultMessage: 'Assign a work item',
		description:
			'Rule name displayed as a label or option in the Jira workflow wizard rule selection interface within the AI conversation interface. Shown as text in a dropdown, menu, or list of available workflow rules. The purpose is to identify the workflow rule that automatically assigns a work item to a specific user when triggered, helping users understand what the rule does.',
	},
	checkFieldValueRuleName: {
		id: 'jira-workflow-editor.workflow-builder.check-field-value-rule-name',
		defaultMessage: 'Restrict to when a field is a specific value',
		description:
			'Rule name displayed as a label or option in the Jira workflow wizard rule selection interface within the AI conversation interface. Shown as text in a dropdown, menu, or list of available workflow rules. The purpose is to identify the workflow rule that restricts an action (such as a transition) to only occur when a specific field has a particular value, helping users understand the conditional logic of the rule.',
	},
	restrictIssueTransitionRuleName: {
		id: 'jira-workflow-editor.workflow-builder.restrict-issue-transition-rule-name',
		defaultMessage: 'Restrict who can move a work item',
		description:
			'Rule name displayed as a label or option in the Jira workflow wizard rule selection interface within the AI conversation interface. Shown as text in a dropdown, menu, or list of available workflow rules. The purpose is to identify the workflow rule that restricts which users or groups can transition (move) a work item between statuses, helping users understand the permission-based restriction.',
	},
	updateFieldRuleName: {
		id: 'jira-workflow-editor.workflow-builder.update-field-rule-name',
		defaultMessage: 'Update a work item field',
		description:
			'Rule name displayed as a label or option in the Jira workflow wizard rule selection interface within the AI conversation interface. Shown as text in a dropdown, menu, or list of available workflow rules. The purpose is to identify the workflow rule that automatically updates a work item field value when triggered, helping users understand what the rule does.',
	},
	validateFieldRuleName: {
		id: 'jira-workflow-editor.workflow-builder.validate-field-rule-name',
		defaultMessage: 'Validate a field',
		description:
			'Rule name displayed as a label or option in the Jira workflow wizard rule selection interface within the AI conversation interface. Shown as text in a dropdown, menu, or list of available workflow rules. The purpose is to identify the workflow rule that validates a field value before allowing a transition or action to proceed, helping users understand the validation logic.',
	},
	ruleHeading: {
		id: 'jira-workflow-editor.workflow-builder.status-heading',
		defaultMessage: 'Rule',
		description:
			'Heading text displayed at the top of a rule card or section in the Jira workflow wizard within the AI conversation interface. Shown as a section header or card title. The purpose is to identify the section that contains workflow rule configuration options, helping users understand they are configuring a workflow automation rule.',
	},
});
export default _default_1;
